import { LoginOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import axios from 'axios';
import { useApp } from '../store/appStores';

export const Login = () => {
  const handleFinish = (values) => {
    axios
      .post('/user/login', values)
      .then((response) => {
        useApp.setState({ token: response.data.access_token });
        axios.defaults.headers.common['Authorization'] =
          `Bearer ${response.data.access_token}`;
        localStorage.setItem('token', response.data.access_token);
      })
      .catch((error) => {});
  };

  return (
    <Form
      onFinish={handleFinish}
      style={{
        maxWidth: '300px',
        margin: '0 auto',
        padding: '20px',
        border: '1px solid #f0f0f0',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
      layout="vertical"
    >
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Iniciar sesión</h1>
      <Form.Item label="Usuario" name="username">
        <Input />
      </Form.Item>
      <Form.Item label="Contraseña" name="password">
        <Input.Password />
      </Form.Item>
      <Button type="primary" htmlType="submit" icon={<LoginOutlined />} block>
        Iniciar sesión
      </Button>
    </Form>
  );
};
